import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { API } from 'aws-amplify';
import { Subscription } from 'rxjs';
import { CONST_AWS_API } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-event-terms-conditions',
  templateUrl: './event-terms-conditions.component.html',
  styleUrls: ['./event-terms-conditions.component.scss']
})
export class EventTermsConditionsComponent implements OnInit {

  loggedIn: boolean;
  streamInfo: any;
  streamInfoSubscription: Subscription;
  clientDetails : any;
  constructor(private matDialogRef:MatDialogRef<EventTermsConditionsComponent>,public router:Router,
    private storageService: StorageService,
    private commanSubscribeService: CommanSubscribeService,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.streamInfo = data;
    }

  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    let userInfo = this.storageService.getItem('user_Info');
    let user = this.commanSubscribeService.userInfo;
    if (userInfo && userInfo.access_token && (!user || !user.id))  {
      this.getUser(userInfo.access_token);
    }
    this.streamInfo = this.commanSubscribeService.streamInfo;
    this.streamInfoSubscription = this.commanSubscribeService.getStreamInfo().subscribe(response => {
      this.streamInfo = response;
    });
  }


  getUser(access_token) {
    
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${access_token}`
      },
      response: true,
      body: {
        // email: this.profileData.email,
        // user_id: this.userInfo.id
      }
    }
    // this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
      // this.ngxLoader.stop();
      let userInfo = response.data.user;
      userInfo.signedIn = true;
      userInfo.access_token = userInfo.session_token;    
      userInfo.is_profile_completed = true;      
      this.commanSubscribeService.sendUserInfo(userInfo);      
    }).catch(error => {
      // this.ngxLoader.stop();      
      console.log(error);
      this.commanSubscribeService.sendUserInfo({});
    });
  }

  close() {
    this.matDialogRef.close();
  }

  ngOnDestroy() {
    if (this.streamInfoSubscription)
      this.streamInfoSubscription.unsubscribe();
  }
}

